import { FC, useMemo, useContext, PropsWithChildren } from 'react';
import TrialConfigurationSourceDataContext from '@/contexts/data/TrialConfigurationSourceDataContext';
import IsLoading from '@/components/layouts/IsLoading';
import TrialContext from '@/contexts/data/TrialContext';
import { useParams } from 'react-router-dom';
import useTrialConfigurationSourceData from '@/hooks/data/useTrialConfigurationSourceData';
import { GetConfigurationSourceDataResponse } from '@/api/dtos';


export interface IConfigurationSourceDataProviderProps {
    initial?: GetConfigurationSourceDataResponse;
}

export const TrialConfigurationSourceDataProvider: FC<PropsWithChildren<IConfigurationSourceDataProviderProps>> = ({ initial, children }) => {
    const { data: trial } = useContext(TrialContext);

    const configurationSourceData = useTrialConfigurationSourceData(trial?.id, { revalidateOnFocus: false, fallbackData: initial});

    return (
        <TrialConfigurationSourceDataContext.Provider value={configurationSourceData}>
            <IsLoading name="trial-configuration-source-data" loading={configurationSourceData.loading} validating={configurationSourceData.validating}/>
            {children}
        </TrialConfigurationSourceDataContext.Provider>
    );
}

export default TrialConfigurationSourceDataProvider;
